export default ratgeberSlider => {
	let $ratgeberList = $('.ratgeber-slider');

	if ($ratgeberList.length < 1) {
		return false;
	}

	let options = {
        arrows: false,
        dots: true,
        mobileFirst: true,
        infinite: true,
        slidesToShow: 2,
        responsive: [
        	{
        		breakpoint: 1075,
				settings: "unslick"
        	},
        	{
        		breakpoint: 650,
				settings: {
        			slidesToShow: 2,
					rows: 1,
				}
        	},
        	{
        		breakpoint: 250,
				settings: {
        			slidesToShow: 1,
					rows: 1,
				}
        	}
		]
	};

	$ratgeberList.slick(options);
};
